import { QrCodeEntity, UsersEntity } from '@/domain/entities/users';
import { UsersRepository } from '@/domain/ports/users/repositories';
import { HttpClientAdapter } from '@/graphql/http-client-adapter';
import {
  CHANGE_PASSWORD,
  GET_USER_BY_FIREBASE_ID,
  GET_USER_BY_ID,
  LOGIN_WITH_TOKEN,
  LOGIN_WITH_USERNAME_AND_PASSWORD,
  LOGOUT_USER,
  REGISTER_WITH_TOKEN,
} from '../../graphql';
import { config } from '@/config';
import { get } from 'lodash';

export class UsersRepoIml implements UsersRepository {
  async get(payload: string): Promise<{ dataDetail: UsersEntity }> {
    const response: UsersEntity = await HttpClientAdapter.query<UsersEntity>({
      query: GET_USER_BY_ID,
      dataKey: 'User_getById',
      variables: { id: payload },
    });
    return {
      dataDetail: response,
    };
  }

  async findFirebaseId(payload: string): Promise<UsersEntity> {
    const response: UsersEntity = await HttpClientAdapter.query<UsersEntity>(
      {
        query: GET_USER_BY_FIREBASE_ID,
        dataKey: 'User_getByFirebaseId',
        variables: { id: payload },
      },
      {
        requiredAuth: false,
      },
    );
    return response;
  }

  async registerWithToken(payload: string): Promise<UsersEntity> {
    const response: UsersEntity = await HttpClientAdapter.mutate<UsersEntity>(
      {
        mutation: REGISTER_WITH_TOKEN,
        variables: { registerWithTokenInput: { token: payload } },
      },
      {
        requiredAuth: false,
      },
    );
    return response;
  }

  async loginWithToken(payload: string): Promise<UsersEntity> {
    const response: UsersEntity = await HttpClientAdapter.mutate<UsersEntity>(
      {
        mutation: LOGIN_WITH_TOKEN,
        variables: { idToken: payload },
      },
      {
        requiredAuth: false,
      },
    );
    return response;
  }

  async loginWithUsernameAndPassword(payload: {
    username: string;
    password: string;
  }): Promise<string> {
    const response = await HttpClientAdapter.mutate<any>(
      {
        mutation: LOGIN_WITH_USERNAME_AND_PASSWORD,
        variables: { username: payload.username, password: payload.password },
        dataKey: 'users',
      },
      {
        requiredAuth: false,
      },
    );
    return response.loginWithUsername.customToken;
  }

  async logoutUser(): Promise<UsersEntity> {
    const response: UsersEntity = await HttpClientAdapter.mutate<UsersEntity>({
      mutation: LOGOUT_USER,
    });
    return response;
  }

  async changePassword(): Promise<UsersEntity> {
    const response: UsersEntity = await HttpClientAdapter.mutate<UsersEntity>({
      mutation: CHANGE_PASSWORD,
    });
    return response;
  }

  async generateQRCode(): Promise<QrCodeEntity> {
    const response = await fetch(config.base.baseUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        operationName: 'QrCode_generate',
        variables: {},
        query:
          'mutation QrCode_generate{QrCode_generate{success,message,qrCodeData,loginToken,expiresIn}}',
      }),
    });
    const data = await response.json();
    return get(data, 'data.QrCode_generate');
  }
}
